import { useCallback, useEffect, useState } from 'react'
import { Dialog, DialogContent, Grid, Paper, Typography, Button } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import EditIcon from '@material-ui/icons/EditOutlined'
import AddIcon from '@material-ui/icons/Add'
import MyDataForm from './MyDataForm'
import MyDoctosForm from './MyDoctosForm'
import { getProvider } from '../../api/providers.service'
import { providerDataKeyNames } from './provider.data.keys'
import ResourceList from '../../components/Resources/ResourceList'
import { removeProviderDocuments } from '../../api/providers.service'
import { toggleModalFullscreen } from '../../redux/features/modalSlice'
import { getProviderConditions } from '../../api/providerConditions.service'

const MyDataView = () => {
  const [isModalFormOpen, setIsModalFormOpen] = useState(false)
  const [isModalDoctoOpen, setIsModalDoctoOpen] = useState(false)
  const [state, setState] = useState({})
  const [doctos, setDoctos] = useState({})
  const [originalProviderData, setOriginalProviderData] = useState({})
  const [acceptedConditions, setAcceptedConditions] = useState([])
  const providerSelected = useSelector((state) => state.provider)
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const getData = useCallback(() => {
    getProvider(providerSelected.id).then(({ data }) => {
      setOriginalProviderData({ ...data })
      let { documents, ...rest } = data
      setDoctos(documents)
      for (const key in rest) {
        if (Object.hasOwnProperty.call(rest, key)) {
          const value = rest[key]
          if (typeof value == 'boolean') rest[key] = value ? 'Si' : 'No'
        }
      }
      setState(rest)
    })

    getProviderConditions(providerSelected.id).then((result) => {
      setAcceptedConditions(result.data.filter((condition) => condition.isAccepted))
    })
  }, [providerSelected.id])

  useEffect(() => {
    getData()
  }, [providerSelected.id, getData])

  const handleClickEdit = () => {
    setIsModalFormOpen(true)
  }

  const handleCloseModalForm = () => {
    setIsModalFormOpen(false)
  }

  const exitFullscreenModalForm = useCallback(() => {
    if (!isModalFormOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isModalFormOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModalForm, 500)
    return () => clearTimeout(timeout)
  }, [isModalFormOpen, exitFullscreenModalForm])

  const handleOpenModalDoctos = () => {
    setIsModalDoctoOpen(true)
  }

  const handleCloseModalDoctos = () => {
    setIsModalDoctoOpen(false)
    getData()
  }

  const handleDeleteFile = async (docto) => {
    await removeProviderDocuments({
      providerId: providerSelected.id,
      documentFileName: docto
    }).then(() => {
      getData()
    })
  }

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography color="secondary">MIS DATOS</Typography>
        </Grid>
        <Grid item xs={6} className="text-right">
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<EditIcon fontSize={'small'} />}
            onClick={handleClickEdit}
          >
            Editar
          </Button>
        </Grid>
        {Object.entries(providerDataKeyNames).map((entry) => {
          if (state[entry[0]] && state[entry[0]] !== null && state[entry[0]] !== '') {
            return (
              <Grid
                key={`provider-data-${entry[0]}`}
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                style={{ wordBreak: 'break-word' }}
              >
                <Typography color="primary" variant="body1">{`${entry[1]}:`}</Typography>
                <Typography variant="body1">{state[entry[0]]}</Typography>
              </Grid>
            )
          }
          return ''
        })}
      </Grid>
      <Grid container spacing={2} className="mt-3">
        <Grid item xs={8}>
          <Typography color="secondary">MIS DOCUMENTOS</Typography>
          <Typography color="primary" variant="caption">
            Por favor añada los documentos: CIF, certificado de calidad, registro sanitario,
            certificado ecológico, entre otros.
          </Typography>
        </Grid>
        <Grid item xs={4} className="text-right">
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<AddIcon fontSize={'small'} />}
            onClick={handleOpenModalDoctos}
          >
            Añadir
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <ResourceList resources={doctos} onDelete={handleDeleteFile} />
        </Grid>
      </Grid>

      <Grid container spacing={2} className="mt-3">
        <Grid item xs={12}>
          <Typography color="secondary">TÉRMINOS Y CONDICIONES ACEPTADOS</Typography>
        </Grid>
        {acceptedConditions.length ? (
          acceptedConditions.map((condition, index) => (
            <Grid key={`accepted-condition-${index}`} container spacing={1} className="mb-2">
              <Grid item>
                <Button
                  variant="contained"
                  size="small"
                  target="_blank"
                  href={condition.englishDocumentUrl}
                >
                  {condition.englishName}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  size="small"
                  target="_blank"
                  href={condition.spanishDocumentUrl}
                >
                  {condition.spanishName}
                </Button>
              </Grid>
            </Grid>
          ))
        ) : (
          <Grid item>
            <Typography color="primary" className="text-left text-sm-center">
              No hay términos y condiciones aceptadas
            </Typography>
          </Grid>
        )}
      </Grid>

      <Dialog
        open={isModalFormOpen}
        onClose={handleCloseModalForm}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <MyDataForm providerData={originalProviderData} onClose={handleCloseModalForm} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalDoctoOpen}
        onClose={handleCloseModalDoctos}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <MyDoctosForm onClose={handleCloseModalDoctos} />
        </DialogContent>
      </Dialog>
    </Paper>
  )
}

export default MyDataView
